import { getLastObject } from './helpers/getLastObject';
import { BiometricDocument } from '../../types';
import { CheckResponse } from './types';
import { PrevStudentVisaCalculation } from './PrevStudentVisa-calculation';
import { BiometricDocumentMap, StudentVisaDocMap } from 'types';

export const BRPCalculation = (
  biometricDocMap?: BiometricDocumentMap,
  studentVisa?: StudentVisaDocMap,
  shortenedDate?: string,
): CheckResponse => {
  const lastBRP = getLastObject<BiometricDocument>(biometricDocMap);

  if (lastBRP && lastBRP.dateOfIssue && lastBRP.validUntil) {
    if (lastBRP.hasDocument) {
      return {
        startDate: lastBRP.dateOfIssue,
        endDate: shortenedDate ? shortenedDate : lastBRP.validUntil,
      };
    }
    return PrevStudentVisaCalculation(studentVisa, shortenedDate);
  }

  return;
};
